<template>
  <div
    class="tw-min-h-full tw-w-full tw-px-[16px] tw-pb-[calc(96px+env(safe-area-inset-bottom))] md:tw-min-h-[80vh] md:tw-px-[32px] md:tw-pb-0"
  >
    <!-- Mobile header -->
    <div
      class="tw-mt-[20px] tw-flex tw-items-start tw-justify-between md:tw-hidden"
    >
      <h1
        class="tw-font-inter tw-text-[28px] tw-font-bold tw-leading-[120%] tw-text-[#3B4143]"
      >
        {{ groupName }}
      </h1>

      <div class="tw-relative">
        <button
          type="button"
          class="tw-flex tw-h-[50px] tw-w-[50px] tw-items-center tw-justify-center tw-rounded-[25px] tw-border tw-border-[#D1D5DB] tw-bg-white tw-p-[13px] hover:tw-border-uhblue-700 hover:tw-text-uhblue-700 focus-visible:tw-border-uhblue-700 focus-visible:tw-text-uhblue-700 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5] focus-visible:tw-ring-offset-2"
          @click.stop="toggleGroupMenu"
          @mousedown.stop
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12 10.5625C12.7939 10.5625 13.4375 11.2061 13.4375 12C13.4375 12.7939 12.7939 13.4375 12 13.4375C11.2061 13.4375 10.5625 12.7939 10.5625 12C10.5625 11.2061 11.2061 10.5625 12 10.5625Z"
              fill="#00A2E1"
              stroke="#00A2E1"
              stroke-width="0.125"
            />
            <path
              d="M5.625 10.5625C6.41891 10.5625 7.0625 11.2061 7.0625 12C7.0625 12.7939 6.41891 13.4375 5.625 13.4375C4.83109 13.4375 4.1875 12.7939 4.1875 12C4.1875 11.2061 4.83109 10.5625 5.625 10.5625Z"
              fill="#00A2E1"
              stroke="#00A2E1"
              stroke-width="0.125"
            />
            <path
              d="M18.375 10.5625C19.1689 10.5625 19.8125 11.2061 19.8125 12C19.8125 12.7939 19.1689 13.4375 18.375 13.4375C17.5811 13.4375 16.9375 12.7939 16.9375 12C16.9375 11.2061 17.5811 10.5625 18.375 10.5625Z"
              fill="#00A2E1"
              stroke="#00A2E1"
              stroke-width="0.125"
            />
          </svg>
        </button>

        <div
          v-if="showGroupMenu"
          class="tw-absolute tw-right-0 tw-top-[60px] tw-z-50 tw-w-[220px] tw-overflow-hidden tw-rounded-[16px] tw-border tw-border-[#E5E7EB] tw-bg-white tw-shadow-[0_4px_8px_0_rgba(0,0,0,0.25)]"
          @click.stop
          @mousedown.stop
        >
          <button
            type="button"
            class="tw-flex tw-w-full tw-items-center tw-gap-[10px] tw-px-[16px] tw-py-[14px] tw-text-left hover:tw-bg-[#F9FAFB]"
            @click="emitAndClose('rename-group')"
          >
            <PencilSimpleLine />
            <span class="tw-font-inter tw-text-[16px] tw-text-[#3B4143]">
              Rename group
            </span>
          </button>

          <button
            v-if="!isConfirmingDeleteGroup"
            type="button"
            class="tw-flex tw-w-full tw-items-center tw-gap-[10px] tw-px-[16px] tw-py-[14px] tw-text-left hover:tw-bg-[#FEF2F2] disabled:tw-cursor-not-allowed disabled:tw-opacity-60"
            :disabled="!canDeleteGroup"
            @click="startDeleteGroupConfirm"
          >
            <Trash />
            <span
              class="tw-font-inter tw-text-[16px] tw-font-normal tw-leading-[150%] tw-text-[#E7000B]"
            >
              Delete group
            </span>
          </button>

          <!-- Inline confirm row -->
          <div v-else class="tw-flex tw-w-full tw-items-stretch">
            <button
              type="button"
              class="tw-flex tw-flex-1 tw-items-center tw-justify-start tw-px-[16px] tw-py-[14px] tw-text-left hover:tw-bg-[#FEF2F2]"
              @click="confirmDeleteGroup"
            >
              <span
                class="tw-font-inter tw-text-[16px] tw-font-normal tw-leading-[150%] tw-text-[#E7000B]"
              >
                Click to confirm
              </span>
            </button>

            <button
              type="button"
              class="tw-flex tw-w-[50px] tw-items-center tw-justify-center tw-border-l tw-border-[#E5E7EB] hover:tw-bg-gray-50"
              aria-label="Cancel delete"
              @click="cancelDeleteGroupConfirm"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M18.75 5.25L5.25 18.75"
                  stroke="#6B7280"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M18.75 18.75L5.25 5.25"
                  stroke="#6B7280"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="tw-mt-[12px] md:tw-hidden">
      <div class="tw-flex tw-items-center tw-justify-between">
        <h2
          class="tw-font-inter tw-m-0 tw-text-[18px] tw-font-semibold tw-leading-none tw-text-[#3B4143]"
        >
          Manage group
        </h2>

        <button
          type="button"
          class="tw-flex tw-items-center tw-gap-2 tw-text-[#00A2E1] hover:tw-text-[#0090C8] focus-visible:tw-text-[#0090C8] focus-visible:tw-rounded-[2px] focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5] focus-visible:tw-ring-offset-2"
          @click="refreshGroupManagementData"
        >
          <ArrowsClockwise fill-color="#00A2E1" />
          <span
            class="tw-font-inter tw-text-[14px] tw-font-semibold tw-leading-[120%]"
          >
            {{
              studentStore.isRefreshingManageGroup
                ? 'Refreshing'
                : 'Refresh grouplist'
            }}
          </span>
        </button>
      </div>
    </div>

    <!-- Desktop: Pending approval table -->
    <div
      v-if="pendingMembers.length"
      class="tw-mt-[24px] tw-hidden md:tw-block"
    >
      <div class="tw-flex tw-items-center tw-gap-[8px]">
        <PendingApproval />
        <h3
          class="tw-font-inter tw-mb-0 tw-text-[16px] tw-font-semibold tw-leading-[150%] tw-text-[#3B4143]"
        >
          Pending approval ({{ pendingMembers.length }})
        </h3>
      </div>

      <div
        class="tw-mt-[12px] tw-overflow-visible tw-rounded-[12px] tw-border tw-border-[#E5E7EB]"
      >
        <div
          class="tw-grid tw-grid-cols-[2fr_2fr_120px] tw-items-center tw-rounded-t-[12px] tw-border-b tw-px-[16px] tw-py-[12px]"
        >
          <div class="tw-font-inter tw-text-[14px] tw-font-semibold">Name</div>
          <div class="tw-font-inter tw-text-[14px] tw-font-semibold">
            Email address
          </div>
          <div
            class="tw-font-inter tw-text-right tw-text-[14px] tw-font-semibold"
          >
            Actions
          </div>
        </div>

        <div class="tw-divide-y tw-divide-[#E5E7EB]">
          <div
            v-for="member in pendingMembers"
            :key="memberKey(member)"
            class="tw-grid tw-grid-cols-[2fr_2fr_120px] tw-items-center tw-px-[16px] tw-py-[12px] tw-transition tw-duration-150"
            :class="{
              'tw-pointer-events-none tw-opacity-60': isMemberLoading(member),
              'tw-cursor-wait tw-bg-[#F9FAFB]': isMemberLoading(member),
            }"
          >
            <div
              class="tw-font-inter tw-text-[14px] tw-text-[#3B4143]"
              :class="{ 'tw-text-[#9CA3AF]': isMemberLoading(member) }"
            >
              {{ member.name || 'Pending member' }}
            </div>
            <div class="tw-font-inter tw-text-[14px] tw-text-[#6B7280]">
              {{ maskedEmail(member.email) }}
            </div>

            <div class="tw-flex tw-justify-end">
              <div class="tw-relative">
                <button
                  type="button"
                  class="tw-flex tw-h-[40px] tw-w-[40px] tw-items-center tw-justify-center tw-rounded-[20px] tw-border tw-border-[#D1D5DB] tw-bg-white tw-p-[8px] focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5] focus-visible:tw-ring-offset-2"
                  @click.stop="toggleMemberMenu(member)"
                  @mousedown.stop
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 10.5625C12.7939 10.5625 13.4375 11.2061 13.4375 12C13.4375 12.7939 12.7939 13.4375 12 13.4375C11.2061 13.4375 10.5625 12.7939 10.5625 12C10.5625 11.2061 11.2061 10.5625 12 10.5625Z"
                      fill="#00A2E1"
                      stroke="#00A2E1"
                      stroke-width="0.125"
                    />
                    <path
                      d="M5.625 10.5625C6.41891 10.5625 7.0625 11.2061 7.0625 12C7.0625 12.7939 6.41891 13.4375 5.625 13.4375C4.83109 13.4375 4.1875 12.7939 4.1875 12C4.1875 11.2061 4.83109 10.5625 5.625 10.5625Z"
                      fill="#00A2E1"
                      stroke="#00A2E1"
                      stroke-width="0.125"
                    />
                    <path
                      d="M18.375 10.5625C19.1689 10.5625 19.8125 11.2061 19.8125 12C19.8125 12.7939 19.1689 13.4375 18.375 13.4375C17.5811 13.4375 16.9375 12.7939 16.9375 12C16.9375 11.2061 17.5811 10.5625 18.375 10.5625Z"
                      fill="#00A2E1"
                      stroke="#00A2E1"
                      stroke-width="0.125"
                    />
                  </svg>
                </button>

                <div
                  v-if="openMemberMenuKey === memberKey(member)"
                  class="tw-absolute tw-right-0 tw-top-[48px] tw-z-50 tw-w-[220px] tw-overflow-hidden tw-rounded-[16px] tw-border tw-border-[#E5E7EB] tw-bg-white tw-shadow-[0_4px_8px_0_rgba(0,0,0,0.25)]"
                  @click.stop
                  @mousedown.stop
                >
                  <button
                    type="button"
                    class="tw-flex tw-w-full tw-items-center tw-gap-[10px] tw-px-[16px] tw-py-[14px] tw-text-left hover:tw-bg-[#F0FDF4]"
                    @click="approve(member)"
                  >
                    <ThumbsUp />
                    <span
                      class="tw-font-inter tw-text-[16px] tw-font-normal tw-leading-[150%] tw-text-[#497D00]"
                    >
                      Approve request
                    </span>
                  </button>

                  <button
                    type="button"
                    class="tw-flex tw-w-full tw-items-center tw-gap-[10px] tw-px-[16px] tw-py-[14px] tw-text-left hover:tw-bg-[#FEF2F2]"
                    @click="decline(member)"
                  >
                    <ThumbsDown />
                    <span
                      class="tw-font-inter tw-text-[16px] tw-font-normal tw-leading-[150%] tw-text-[#E7000B]"
                    >
                      Decline request
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile: Pending approval list -->
    <div v-if="pendingMembers.length" class="tw-mt-[24px] md:tw-hidden">
      <div class="tw-flex tw-items-center tw-gap-[8px]">
        <PendingApproval />
        <h3
          class="tw-font-inter tw-mb-0 tw-text-[16px] tw-font-semibold tw-leading-[150%] tw-text-[#3B4143]"
        >
          Pending approval ({{ pendingMembers.length }})
        </h3>
      </div>

      <div class="tw-mt-[12px] tw-divide-y tw-divide-[#E5E7EB]">
        <div
          v-for="member in pendingMembers"
          :key="memberKey(member)"
          class="tw-flex tw-items-start tw-justify-between tw-py-[14px] tw-transition tw-duration-150"
          :class="{
            'tw-pointer-events-none tw-opacity-60': isMemberLoading(member),
            'tw-cursor-wait tw-bg-[#F9FAFB]': isMemberLoading(member),
          }"
        >
          <div class="tw-min-w-0">
            <div class="tw-flex tw-items-center tw-gap-[10px]">
              <div
                class="tw-font-inter tw-text-[16px] tw-font-normal tw-leading-[150%] tw-text-[#3B4143]"
                :class="{ 'tw-text-[#9CA3AF]': isMemberLoading(member) }"
              >
                {{ member.name || 'Pending member' }}
              </div>
              <span
                class="tw-font-inter tw-rounded-[8px] tw-bg-[#E0F2FE] tw-px-[8px] tw-py-[2px] tw-text-[12px] tw-font-semibold tw-leading-[150%] tw-text-[#0284C7]"
              >
                Pending
              </span>
            </div>

            <div
              class="tw-font-inter tw-mt-[2px] tw-text-[14px] tw-font-normal tw-leading-[150%] tw-text-[#6B7280]"
            >
              {{ maskedEmail(member.email) }}
            </div>
          </div>

          <div class="tw-relative tw-ml-[12px] tw-flex-shrink-0">
            <button
              type="button"
              class="tw-flex tw-h-[50px] tw-w-[50px] tw-items-center tw-justify-center tw-rounded-[25px] tw-border tw-border-[#D1D5DB] tw-bg-white tw-p-[13px]"
              @click.stop="toggleMemberMenu(member)"
              @mousedown.stop
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M12 10.5625C12.7939 10.5625 13.4375 11.2061 13.4375 12C13.4375 12.7939 12.7939 13.4375 12 13.4375C11.2061 13.4375 10.5625 12.7939 10.5625 12C10.5625 11.2061 11.2061 10.5625 12 10.5625Z"
                  fill="#00A2E1"
                  stroke="#00A2E1"
                  stroke-width="0.125"
                />
                <path
                  d="M5.625 10.5625C6.41891 10.5625 7.0625 11.2061 7.0625 12C7.0625 12.7939 6.41891 13.4375 5.625 13.4375C4.83109 13.4375 4.1875 12.7939 4.1875 12C4.1875 11.2061 4.83109 10.5625 5.625 10.5625Z"
                  fill="#00A2E1"
                  stroke="#00A2E1"
                  stroke-width="0.125"
                />
                <path
                  d="M18.375 10.5625C19.1689 10.5625 19.8125 11.2061 19.8125 12C19.8125 12.7939 19.1689 13.4375 18.375 13.4375C17.5811 13.4375 16.9375 12.7939 16.9375 12C16.9375 11.2061 17.5811 10.5625 18.375 10.5625Z"
                  fill="#00A2E1"
                  stroke="#00A2E1"
                  stroke-width="0.125"
                />
              </svg>
            </button>

            <div
              v-if="openMemberMenuKey === memberKey(member)"
              class="tw-absolute tw-right-0 tw-top-[60px] tw-z-10 tw-w-[220px] tw-overflow-hidden tw-rounded-[16px] tw-border tw-border-[#E5E7EB] tw-bg-white tw-shadow-[0_4px_8px_0_rgba(0,0,0,0.25)]"
              @click.stop
              @mousedown.stop
            >
              <button
                type="button"
                class="tw-flex tw-w-full tw-items-center tw-gap-[10px] tw-px-[16px] tw-py-[14px] tw-text-left hover:tw-bg-[#F0FDF4]"
                @click="approve(member)"
              >
                <ThumbsUp />
                <span
                  class="tw-font-inter tw-text-[16px] tw-font-normal tw-leading-[150%] tw-text-[#497D00]"
                >
                  Approve request
                </span>
              </button>

              <button
                type="button"
                class="tw-flex tw-w-full tw-items-center tw-gap-[10px] tw-px-[16px] tw-py-[14px] tw-text-left hover:tw-bg-[#FEF2F2]"
                @click="decline(member)"
              >
                <ThumbsDown />
                <span
                  class="tw-font-inter tw-text-[16px] tw-font-normal tw-leading-[150%] tw-text-[#E7000B]"
                >
                  Decline request
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Desktop: Active members table -->
    <div class="tw-mt-[24px] tw-hidden md:tw-block">
      <div class="tw-flex tw-items-center tw-gap-[8px]">
        <ActiveMembers />
        <h3
          class="tw-font-inter tw-mb-0 tw-text-[16px] tw-font-semibold tw-leading-[150%] tw-text-[#3B4143]"
        >
          Active members
        </h3>
      </div>

      <div
        class="tw-mt-[12px] tw-overflow-visible tw-rounded-[12px] tw-border tw-border-[#E5E7EB]"
      >
        <div
          class="tw-grid tw-grid-cols-[2fr_2fr_120px] tw-items-center tw-rounded-t-[12px] tw-border-b tw-px-[16px] tw-py-[12px]"
        >
          <div class="tw-font-inter tw-text-[14px] tw-font-semibold">Name</div>
          <div class="tw-font-inter tw-text-[14px] tw-font-semibold">
            Email address
          </div>
          <div
            class="tw-font-inter tw-text-right tw-text-[14px] tw-font-semibold"
          >
            Actions
          </div>
        </div>

        <div class="tw-divide-y tw-divide-[#E5E7EB]">
          <div
            v-for="member in activeMembers"
            :key="memberKey(member)"
            class="tw-grid tw-grid-cols-[2fr_2fr_120px] tw-items-center tw-px-[16px] tw-py-[12px] tw-transition tw-duration-150"
            :class="{
              'tw-pointer-events-none tw-opacity-60': isMemberLoading(member),
              'tw-cursor-wait tw-bg-[#F9FAFB]': isMemberLoading(member),
            }"
          >
            <div class="tw-flex tw-items-center tw-gap-[10px]">
              <div
                class="tw-font-inter tw-text-[14px] tw-text-[#3B4143]"
                :class="{ 'tw-text-[#9CA3AF]': isMemberLoading(member) }"
              >
                {{ member.name || 'Member' }}
              </div>
              <span
                v-if="isCurrentUser(member)"
                class="tw-font-inter tw-rounded-[8px] tw-bg-[#FFEDD5] tw-px-[8px] tw-py-[2px] tw-text-[12px] tw-font-semibold tw-leading-[150%] tw-text-[#9A3412]"
              >
                You
              </span>
            </div>

            <div class="tw-font-inter tw-text-[14px] tw-text-[#6B7280]">
              {{ maskedEmail(member.email) }}
            </div>

            <div class="tw-flex tw-justify-end">
              <div class="tw-relative">
                <button
                  type="button"
                  class="tw-flex tw-h-[40px] tw-w-[40px] tw-items-center tw-justify-center tw-rounded-[20px] tw-border tw-border-[#D1D5DB] tw-bg-white tw-p-[8px] focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5] focus-visible:tw-ring-offset-2"
                  @click.stop="toggleMemberMenu(member)"
                  @mousedown.stop
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 10.5625C12.7939 10.5625 13.4375 11.2061 13.4375 12C13.4375 12.7939 12.7939 13.4375 12 13.4375C11.2061 13.4375 10.5625 12.7939 10.5625 12C10.5625 11.2061 11.2061 10.5625 12 10.5625Z"
                      fill="#00A2E1"
                      stroke="#00A2E1"
                      stroke-width="0.125"
                    />
                    <path
                      d="M5.625 10.5625C6.41891 10.5625 7.0625 11.2061 7.0625 12C7.0625 12.7939 6.41891 13.4375 5.625 13.4375C4.83109 13.4375 4.1875 12.7939 4.1875 12C4.1875 11.2061 4.83109 10.5625 5.625 10.5625Z"
                      fill="#00A2E1"
                      stroke="#00A2E1"
                      stroke-width="0.125"
                    />
                    <path
                      d="M18.375 10.5625C19.1689 10.5625 19.8125 11.2061 19.8125 12C19.8125 12.7939 19.1689 13.4375 18.375 13.4375C17.5811 13.4375 16.9375 12.7939 16.9375 12C16.9375 11.2061 17.5811 10.5625 18.375 10.5625Z"
                      fill="#00A2E1"
                      stroke="#00A2E1"
                      stroke-width="0.125"
                    />
                  </svg>
                </button>

                <div
                  v-if="openMemberMenuKey === memberKey(member)"
                  class="tw-absolute tw-right-0 tw-top-[48px] tw-z-50 tw-w-[220px] tw-overflow-hidden tw-rounded-[16px] tw-border tw-border-[#E5E7EB] tw-bg-white tw-shadow-[0_4px_8px_0_rgba(0,0,0,0.25)]"
                  @click.stop
                  @mousedown.stop
                >
                  <button
                    v-if="
                      isCurrentUser(member) &&
                      canDeleteGroup &&
                      !isConfirmingDeleteGroup
                    "
                    type="button"
                    class="tw-flex tw-w-full tw-items-center tw-gap-[10px] tw-px-[16px] tw-py-[14px] tw-text-left hover:tw-bg-[#FEF2F2]"
                    @click="startDeleteGroupConfirm"
                  >
                    <Trash />
                    <span
                      class="tw-font-inter tw-text-[16px] tw-font-normal tw-leading-[150%] tw-text-[#E7000B]"
                    >
                      Delete group
                    </span>
                  </button>

                  <div
                    v-else-if="
                      isCurrentUser(member) &&
                      canDeleteGroup &&
                      isConfirmingDeleteGroup
                    "
                    class="tw-flex tw-w-full tw-items-stretch"
                  >
                    <button
                      type="button"
                      class="tw-flex tw-flex-1 tw-items-center tw-justify-start tw-px-[16px] tw-py-[14px] tw-text-left hover:tw-bg-[#FEF2F2]"
                      @click="confirmDeleteGroupImmediate"
                    >
                      <span
                        class="tw-font-inter tw-text-[16px] tw-font-normal tw-leading-[150%] tw-text-[#E7000B]"
                      >
                        Click to confirm
                      </span>
                    </button>

                    <button
                      type="button"
                      class="tw-flex tw-w-[50px] tw-items-center tw-justify-center tw-border-l tw-border-[#E5E7EB] hover:tw-bg-gray-50"
                      aria-label="Cancel delete"
                      @click="cancelDeleteGroupConfirm"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M18.75 5.25L5.25 18.75"
                          stroke="#6B7280"
                          stroke-width="2.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M18.75 18.75L5.25 5.25"
                          stroke="#6B7280"
                          stroke-width="2.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>

                  <div
                    v-else-if="
                      isCurrentUser(member) &&
                      confirmingLeaveMemberKey === memberKey(member)
                    "
                    class="tw-flex tw-w-full tw-items-stretch"
                  >
                    <button
                      type="button"
                      class="tw-flex tw-flex-1 tw-items-center tw-justify-start tw-px-[16px] tw-py-[14px] tw-text-left hover:tw-bg-[#FEF2F2]"
                      @click="confirmLeave(member)"
                    >
                      <span
                        class="tw-font-inter tw-text-[16px] tw-font-normal tw-leading-[150%] tw-text-[#E7000B]"
                      >
                        Click to confirm
                      </span>
                    </button>

                    <button
                      type="button"
                      class="tw-flex tw-w-[50px] tw-items-center tw-justify-center tw-border-l tw-border-[#E5E7EB] hover:tw-bg-gray-50"
                      aria-label="Cancel leave"
                      @click="cancelLeaveConfirm"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M18.75 5.25L5.25 18.75"
                          stroke="#6B7280"
                          stroke-width="2.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M18.75 18.75L5.25 5.25"
                          stroke="#6B7280"
                          stroke-width="2.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>

                  <button
                    v-else-if="
                      isCurrentUser(member) &&
                      confirmingLeaveMemberKey !== memberKey(member)
                    "
                    type="button"
                    class="tw-flex tw-w-full tw-items-center tw-gap-[10px] tw-px-[16px] tw-py-[14px] tw-text-left hover:tw-bg-[#FEF2F2]"
                    @click="startLeaveConfirm(member)"
                  >
                    <Trash />
                    <span
                      class="tw-font-inter tw-text-[16px] tw-font-normal tw-leading-[150%] tw-text-[#E7000B]"
                    >
                      Leave group
                    </span>
                  </button>

                  <div
                    v-else-if="
                      !isCurrentUser(member) &&
                      confirmingRemoveMemberKey === memberKey(member)
                    "
                    class="tw-flex tw-w-full tw-items-stretch"
                  >
                    <button
                      type="button"
                      class="tw-flex tw-flex-1 tw-items-center tw-justify-start tw-px-[16px] tw-py-[14px] tw-text-left hover:tw-bg-[#FEF2F2]"
                      @click="confirmRemove(member)"
                    >
                      <span
                        class="tw-font-inter tw-text-[16px] tw-font-normal tw-leading-[150%] tw-text-[#E7000B]"
                      >
                        Click to confirm
                      </span>
                    </button>

                    <button
                      type="button"
                      class="tw-flex tw-w-[50px] tw-items-center tw-justify-center tw-border-l tw-border-[#E5E7EB] hover:tw-bg-gray-50"
                      aria-label="Cancel remove"
                      @click="cancelRemoveConfirm"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M18.75 5.25L5.25 18.75"
                          stroke="#6B7280"
                          stroke-width="2.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M18.75 18.75L5.25 5.25"
                          stroke="#6B7280"
                          stroke-width="2.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>

                  <button
                    v-else
                    type="button"
                    class="tw-flex tw-w-full tw-items-center tw-gap-[10px] tw-px-[16px] tw-py-[14px] tw-text-left hover:tw-bg-[#FEF2F2]"
                    @click="startRemoveConfirm(member)"
                  >
                    <Trash />
                    <span
                      class="tw-font-inter tw-text-[16px] tw-font-normal tw-leading-[150%] tw-text-[#E7000B]"
                    >
                      Remove from group
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile: Active members list -->
    <div class="tw-mt-[24px] md:tw-hidden">
      <div class="tw-flex tw-items-center tw-gap-[8px]">
        <Users />
        <h3
          class="tw-font-inter tw-mb-0 tw-text-[16px] tw-font-semibold tw-leading-[150%] tw-text-[#3B4143]"
        >
          Active members
        </h3>
      </div>

      <div class="tw-mt-[12px] tw-divide-y tw-divide-[#E5E7EB]">
        <div
          v-for="member in activeMembers"
          :key="memberKey(member)"
          class="tw-flex tw-items-start tw-justify-between tw-py-[14px] tw-transition tw-duration-150"
          :class="{
            'tw-pointer-events-none tw-opacity-60': isMemberLoading(member),
            'tw-cursor-wait tw-bg-[#F9FAFB]': isMemberLoading(member),
          }"
        >
          <div class="tw-min-w-0">
            <div class="tw-flex tw-items-center tw-gap-[10px]">
              <div
                class="tw-font-inter tw-text-[16px] tw-font-normal tw-leading-[150%] tw-text-[#3B4143]"
                :class="{ 'tw-text-[#9CA3AF]': isMemberLoading(member) }"
              >
                {{ member.name || 'Member' }}
              </div>
              <span
                v-if="isCurrentUser(member)"
                class="tw-font-inter tw-rounded-[8px] tw-bg-[#FFEDD5] tw-px-[8px] tw-py-[2px] tw-text-[12px] tw-font-semibold tw-leading-[150%] tw-text-[#9A3412]"
              >
                You
              </span>
            </div>

            <div
              class="tw-font-inter tw-mt-[2px] tw-text-[14px] tw-font-normal tw-leading-[150%] tw-text-[#6B7280]"
            >
              {{ maskedEmail(member.email) }}
            </div>
          </div>

          <div class="tw-relative tw-ml-[12px] tw-flex-shrink-0">
            <button
              type="button"
              class="tw-flex tw-h-[50px] tw-w-[50px] tw-items-center tw-justify-center tw-rounded-[25px] tw-border tw-border-[#D1D5DB] tw-bg-white tw-p-[13px]"
              @click.stop="toggleMemberMenu(member)"
              @mousedown.stop
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M12 10.5625C12.7939 10.5625 13.4375 11.2061 13.4375 12C13.4375 12.7939 12.7939 13.4375 12 13.4375C11.2061 13.4375 10.5625 12.7939 10.5625 12C10.5625 11.2061 11.2061 10.5625 12 10.5625Z"
                  fill="#00A2E1"
                  stroke="#00A2E1"
                  stroke-width="0.125"
                />
                <path
                  d="M5.625 10.5625C6.41891 10.5625 7.0625 11.2061 7.0625 12C7.0625 12.7939 6.41891 13.4375 5.625 13.4375C4.83109 13.4375 4.1875 12.7939 4.1875 12C4.1875 11.2061 4.83109 10.5625 5.625 10.5625Z"
                  fill="#00A2E1"
                  stroke="#00A2E1"
                  stroke-width="0.125"
                />
                <path
                  d="M18.375 10.5625C19.1689 10.5625 19.8125 11.2061 19.8125 12C19.8125 12.7939 19.1689 13.4375 18.375 13.4375C17.5811 13.4375 16.9375 12.7939 16.9375 12C16.9375 11.2061 17.5811 10.5625 18.375 10.5625Z"
                  fill="#00A2E1"
                  stroke="#00A2E1"
                  stroke-width="0.125"
                />
              </svg>
            </button>

            <div
              v-if="openMemberMenuKey === memberKey(member)"
              class="tw-absolute tw-right-0 tw-top-[60px] tw-z-10 tw-w-[220px] tw-overflow-hidden tw-rounded-[16px] tw-border tw-border-[#E5E7EB] tw-bg-white tw-shadow-[0_4px_8px_0_rgba(0,0,0,0.25)]"
              @click.stop
              @mousedown.stop
            >
              <button
                v-if="
                  isCurrentUser(member) &&
                  canDeleteGroup &&
                  !isConfirmingDeleteGroup
                "
                type="button"
                class="tw-flex tw-w-full tw-items-center tw-gap-[10px] tw-px-[16px] tw-py-[14px] tw-text-left hover:tw-bg-[#FEF2F2]"
                @click="startDeleteGroupConfirm"
              >
                <Trash />
                <span
                  class="tw-font-inter tw-text-[16px] tw-font-normal tw-leading-[150%] tw-text-[#E7000B]"
                >
                  Delete group
                </span>
              </button>

              <div
                v-else-if="
                  isCurrentUser(member) &&
                  canDeleteGroup &&
                  isConfirmingDeleteGroup
                "
                class="tw-flex tw-w-full tw-items-stretch"
              >
                <button
                  type="button"
                  class="tw-flex tw-flex-1 tw-items-center tw-justify-start tw-px-[16px] tw-py-[14px] tw-text-left hover:tw-bg-[#FEF2F2]"
                  @click="confirmDeleteGroupImmediate"
                >
                  <span
                    class="tw-font-inter tw-text-[16px] tw-font-normal tw-leading-[150%] tw-text-[#E7000B]"
                  >
                    Click to confirm
                  </span>
                </button>

                <button
                  type="button"
                  class="tw-flex tw-w-[50px] tw-items-center tw-justify-center tw-border-l tw-border-[#E5E7EB] hover:tw-bg-gray-50"
                  aria-label="Cancel delete"
                  @click="cancelDeleteGroupConfirm"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M18.75 5.25L5.25 18.75"
                      stroke="#6B7280"
                      stroke-width="2.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18.75 18.75L5.25 5.25"
                      stroke="#6B7280"
                      stroke-width="2.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>

              <div
                v-else-if="
                  isCurrentUser(member) &&
                  confirmingLeaveMemberKey === memberKey(member)
                "
                class="tw-flex tw-w-full tw-items-stretch"
              >
                <button
                  type="button"
                  class="tw-flex tw-flex-1 tw-items-center tw-justify-start tw-px-[16px] tw-py-[14px] tw-text-left hover:tw-bg-[#FEF2F2]"
                  @click="confirmLeave(member)"
                >
                  <span
                    class="tw-font-inter tw-text-[16px] tw-font-normal tw-leading-[150%] tw-text-[#E7000B]"
                  >
                    Click to confirm
                  </span>
                </button>

                <button
                  type="button"
                  class="tw-flex tw-w-[50px] tw-items-center tw-justify-center tw-border-l tw-border-[#E5E7EB] hover:tw-bg-gray-50"
                  aria-label="Cancel leave"
                  @click="cancelLeaveConfirm"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M18.75 5.25L5.25 18.75"
                      stroke="#6B7280"
                      stroke-width="2.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18.75 18.75L5.25 5.25"
                      stroke="#6B7280"
                      stroke-width="2.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>

              <button
                v-else-if="
                  isCurrentUser(member) &&
                  confirmingLeaveMemberKey !== memberKey(member)
                "
                type="button"
                class="tw-flex tw-w-full tw-items-center tw-gap-[10px] tw-px-[16px] tw-py-[14px] tw-text-left hover:tw-bg-[#FEF2F2]"
                @click="startLeaveConfirm(member)"
              >
                <Trash />
                <span
                  class="tw-font-inter tw-text-[16px] tw-font-normal tw-leading-[150%] tw-text-[#E7000B]"
                >
                  Leave group
                </span>
              </button>

              <div
                v-else-if="
                  !isCurrentUser(member) &&
                  confirmingRemoveMemberKey === memberKey(member)
                "
                class="tw-flex tw-w-full tw-items-stretch"
              >
                <button
                  type="button"
                  class="tw-flex tw-flex-1 tw-items-center tw-justify-start tw-px-[16px] tw-py-[14px] tw-text-left hover:tw-bg-[#FEF2F2]"
                  @click="confirmRemove(member)"
                >
                  <span
                    class="tw-font-inter tw-text-[16px] tw-font-normal tw-leading-[150%] tw-text-[#E7000B]"
                  >
                    Click to confirm
                  </span>
                </button>

                <button
                  type="button"
                  class="tw-flex tw-w-[50px] tw-items-center tw-justify-center tw-border-l tw-border-[#E5E7EB] hover:tw-bg-gray-50"
                  aria-label="Cancel remove"
                  @click="cancelRemoveConfirm"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M18.75 5.25L5.25 18.75"
                      stroke="#6B7280"
                      stroke-width="2.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18.75 18.75L5.25 5.25"
                      stroke="#6B7280"
                      stroke-width="2.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>

              <button
                v-else
                type="button"
                class="tw-flex tw-w-full tw-items-center tw-gap-[10px] tw-px-[16px] tw-py-[14px] tw-text-left hover:tw-bg-[#FEF2F2]"
                @click="startRemoveConfirm(member)"
              >
                <Trash />
                <span
                  class="tw-font-inter tw-text-[16px] tw-font-normal tw-leading-[150%] tw-text-[#E7000B]"
                >
                  Remove from group
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="tw-fixed tw-inset-x-0 tw-bottom-0 tw-z-50 tw-flex tw-w-full tw-items-center tw-justify-between tw-border-t tw-border-[#D1D5DB] tw-bg-white tw-p-[16px] tw-pb-[calc(16px+env(safe-area-inset-bottom))] md:tw-hidden"
    >
      <button
        type="button"
        class="tw-font-inter tw-border-none tw-bg-transparent tw-p-0 tw-text-center tw-text-[16px] tw-font-bold tw-leading-[150%] tw-text-[#3B4143]"
        @click="$emit('back')"
      >
        Back
      </button>

      <button
        type="button"
        class="tw-font-inter tw-flex tw-h-[50px] tw-items-center tw-justify-center tw-rounded-[30px] tw-border tw-border-[#D1D5DB] tw-bg-white tw-px-[24px] tw-py-[8px] tw-text-[16px] tw-font-semibold tw-leading-[150%] tw-text-[#3B4143] hover:tw-border-uhblue-700 hover:tw-text-uhblue-700 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5] focus-visible:tw-ring-offset-2"
        @click="handleShare"
      >
        {{ shareLabel }}
      </button>
    </div>
  </div>
</template>

<script>
import PencilSimpleLine from '@components/Student/SVG/PencilSimpleLine.vue';
import Trash from '@components/Student/SVG/Trash.vue';
import PendingApproval from '@components/Student/SVG/PendingApproval.vue';
import ActiveMembers from '@components/Student/SVG/ActiveMembers.vue';
import Users from '@components/Student/SVG/Users.vue';
import ThumbsUp from '@components/Student/SVG/ThumbsUp.vue';
import ThumbsDown from '@components/Student/SVG/ThumbsDown.vue';
import { useStudentStore } from '@js/stores/student/student';
import ArrowsClockwise from '@components/Student/SVG/ArrowsClockwise.vue';

export default {
  name: 'HousemateGroupManage',
  components: {
    ArrowsClockwise,
    PencilSimpleLine,
    Trash,
    PendingApproval,
    ActiveMembers,
    Users,
    ThumbsUp,
    ThumbsDown,
  },
  props: {
    group: { type: Object, default: () => ({}) },
    studentId: { type: [Number, String], default: null },
    shareUrl: { type: String, default: null },
    loadingMemberStudentIds: { type: Array, default: () => [] },
  },
  emits: [
    'back',
    'approve-member',
    'decline-member',
    'rename-group',
    'delete-group',
    'delete-group-immediate',
    'leave-group',
    'remove-member',
  ],
  data() {
    const studentStore = useStudentStore();

    return {
      studentStore,
      showGroupMenu: false,
      openMemberMenuKey: null,
      shareLabel: 'Share link to invite housemates',
      isConfirmingDeleteGroup: false,
      confirmingLeaveMemberKey: null,
      confirmingRemoveMemberKey: null,
    };
  },
  computed: {
    groupName() {
      return this.group?.name ?? 'Group';
    },
    members() {
      return Array.isArray(this.group?.housemate_group_members)
        ? this.group.housemate_group_members
        : [];
    },
    pendingMembers() {
      return this.members.filter((member) => member?.status === 'PENDING');
    },
    activeMembers() {
      return this.members.filter((member) => member?.status === 'APPROVED');
    },
    canDeleteGroup() {
      // Mirrors backend rule: only delete when there is 1 person in group.
      // Treat pending join requests as additional participants.
      return (
        this.activeMembers.length === 1 && this.pendingMembers.length === 0
      );
    },
  },
  mounted() {
    document.addEventListener('click', this.handleDocumentClick);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleDocumentClick);
  },
  methods: {
    memberStudentId(member) {
      return member?.student_id ?? member?.id;
    },
    isMemberLoading(member) {
      const id = this.memberStudentId(member);
      if (!id) return false;

      const ids = Array.isArray(this.loadingMemberStudentIds)
        ? this.loadingMemberStudentIds
        : [];

      return ids.map(String).includes(String(id));
    },
    handleDocumentClick() {
      this.showGroupMenu = false;
      this.openMemberMenuKey = null;
      this.isConfirmingDeleteGroup = false;
      this.confirmingLeaveMemberKey = null;
      this.confirmingRemoveMemberKey = null;
    },
    toggleGroupMenu() {
      this.showGroupMenu = !this.showGroupMenu;
      this.openMemberMenuKey = null;
      if (!this.showGroupMenu) {
        this.isConfirmingDeleteGroup = false;
      }
    },
    emitAndClose(eventName) {
      this.showGroupMenu = false;
      this.openMemberMenuKey = null;
      this.isConfirmingDeleteGroup = false;
      this.confirmingLeaveMemberKey = null;
      this.confirmingRemoveMemberKey = null;
      this.$emit(eventName);
    },
    memberKey(member) {
      const pivotStudentId = this.memberStudentId(member);
      return String(
        pivotStudentId ?? member?.id ?? member?.email ?? member?.name
      );
    },
    toggleMemberMenu(member) {
      const key = this.memberKey(member);
      this.openMemberMenuKey = this.openMemberMenuKey === key ? null : key;
      this.showGroupMenu = false;
      this.isConfirmingDeleteGroup = false;
      this.confirmingLeaveMemberKey = null;
      this.confirmingRemoveMemberKey = null;
    },
    isCurrentUser(member) {
      if (!this.studentId) return false;
      return String(this.memberStudentId(member)) === String(this.studentId);
    },
    maskedEmail(email) {
      if (!email || typeof email !== 'string' || !email.includes('@')) {
        return email ?? '';
      }

      const [local, domain] = email.split('@');
      if (!local) return email;

      const start = local.slice(0, 2);
      const end = local.length > 4 ? local.slice(-2) : '';

      return `${start}***${end}@${domain}`;
    },
    async handleShare() {
      if (!this.shareUrl) {
        this.shareLabel = 'Error!';
        return;
      }

      try {
        if (navigator.share) {
          await navigator.share({
            title: 'UniHomes',
            text: `Join my housemate group using this link:\n${this.shareUrl}`,
            url: this.shareUrl,
          });

          return;
        }

        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(this.shareUrl);
          this.shareLabel = 'Link copied';
        }
      } catch (err) {
        void err;
      } finally {
        setTimeout(() => {
          this.shareLabel = 'Share link to invite housemates';
        }, 3000);
      }
    },
    approve(member) {
      this.openMemberMenuKey = null;
      this.$emit('approve-member', member);
    },
    decline(member) {
      this.openMemberMenuKey = null;
      this.$emit('decline-member', member);
    },
    startDeleteGroupConfirm() {
      if (!this.canDeleteGroup) return;
      this.isConfirmingDeleteGroup = true;
    },
    cancelDeleteGroupConfirm() {
      this.isConfirmingDeleteGroup = false;
    },
    confirmDeleteGroup() {
      if (!this.canDeleteGroup) return;
      this.isConfirmingDeleteGroup = false;
      this.emitAndClose('delete-group');
    },
    confirmDeleteGroupImmediate() {
      if (!this.canDeleteGroup) return;
      this.isConfirmingDeleteGroup = false;
      this.emitAndClose('delete-group-immediate');
    },
    startLeaveConfirm(member) {
      this.confirmingLeaveMemberKey = this.memberKey(member);
    },
    cancelLeaveConfirm() {
      this.confirmingLeaveMemberKey = null;
    },
    confirmLeave(member) {
      this.confirmingLeaveMemberKey = null;
      this.leave(member);
    },
    leave(member) {
      this.openMemberMenuKey = null;
      this.$emit('leave-group', member);
    },
    startRemoveConfirm(member) {
      if (this.isCurrentUser(member)) {
        return;
      }

      this.confirmingRemoveMemberKey = this.memberKey(member);
    },
    cancelRemoveConfirm() {
      this.confirmingRemoveMemberKey = null;
    },
    confirmRemove(member) {
      if (this.isCurrentUser(member)) {
        return;
      }

      this.confirmingRemoveMemberKey = null;
      this.remove(member);
    },
    remove(member) {
      this.openMemberMenuKey = null;
      this.$emit('remove-member', member);
    },
    refreshGroupManagementData() {
      if (!this.studentStore.isRefreshingManageGroup) {
        this.studentStore.handleHousemateDataRefresh();
      }
    },
  },
};
</script>
